import survey_result_router from "@/router/survey_result_router";
import user_router from "@/router/user_router";
import about_router from "@/router/about_router";
import knowledgeBase_router from "@/router/knowledgeBase_router";
import { createRouter, createWebHashHistory } from "vue-router";

export const routes = [
  {
    path: '/dc/:consultantId',
    name: '主页0',
    component: () => import("../page/main"),
  },
  {
    path: '/sc/:email/:consultantId',
    name: '便捷录入',
    component: () => import("../page/surveyEasy/index"),
  },
  {
    path: '/',
    name: '主页',
    component: () => import("../page/main"),
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: 'home',
        name: '家页面',
        component: () => import("../page/home/home")
      },
      {
        path: 'survey',
        name: '信号录入',
        component: () => import("../page/survey/survey"),
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'processing',
        name: '信号处理',
        component: () => import("../page/signalProcessing/index"),
      },
      {
        path: 'common',
        name: '常识库',
        component: () => import("../page/knowledgeBase"),
      },
      {
        path: 'mine',
        name: '我的',
        component: () => import("../page/mine/mine"),
      },
    ]
  },
  ...survey_result_router,
  ...user_router,
  ...about_router,
  {
    path: '/myConsultant',
    name: '我的顾问',
    component: () => import("../page/mine/myConsultant"),
  },
  {
    path: '/updatePersonalInfo',
    name: '修改基本信息',
    component: () => import("../page/user/personalInfo")
  },
  {
    path: '/updatePassword',
    name: '修改密码',
    component: () => import("../page/user/updatePassword")
  },
  ...knowledgeBase_router,
]
const router = createRouter({
  history: createWebHashHistory(),
  routes,
})
export default router
